import React from 'react'

import style from './chat.module.scss'

class Chat extends React.Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    console.log('Hello from the Chat component!')
  }

  render() {
    return <div className={style.chat} onClick={this.handleClick} />
  }
}

export default Chat
